// Utilities for Postman visualization

const getWorkspaceTypeColor = (type) => {
  switch (type?.toLowerCase()) {
    case 'personal': return '#10b981';
    case 'team': return '#3b82f6';
    case 'private': return '#8b5cf6';
    default: return '#6b7280';
  }
};

const getWorkspaceVisibilityColor = (visibility) => {
  switch (visibility?.toLowerCase()) {
    case 'personal': return '#22c55e';
    case 'private': return '#ef4444';
    case 'public': return '#3b82f6';
    default: return '#6b7280';
  }
};

const getRoleColor = (scope) => {
  switch (scope?.toLowerCase()) {
    case 'user': return '#10b981';
    case 'admin': return '#ef4444';
    case 'owner': return '#8b5cf6';
    default: return '#6b7280';
  }
};

const groupWorkspacesByType = (workspaces) => {
  const groups = {};
  workspaces.forEach(workspace => {
    const type = workspace.type || 'unknown';
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(workspace);
  });
  return groups;
};

const groupWorkspacesByVisibility = (workspaces) => {
  const groups = {};
  workspaces.forEach(workspace => {
    const visibility = workspace.visibility || 'unknown';
    if (!groups[visibility]) {
      groups[visibility] = [];
    }
    groups[visibility].push(workspace);
  });
  return groups;
};

const groupRolesByScope = (roles) => {
  const groups = {};
  roles.forEach(role => {
    const scope = role.scope || 'unknown';
    if (!groups[scope]) {
      groups[scope] = [];
    }
    groups[scope].push(role);
  });
  return groups;
};

const getWorkspaceDisplayLabel = (workspace) => {
  return `${workspace.name || 'Unnamed Workspace'}\n${workspace.type || 'unknown'} • ${workspace.visibility || 'unknown'}`;
};

const getRoleDisplayLabel = (role) => {
  return `${role.scope || 'Unknown Role'}\n${role.permissions || 'No permissions specified'}`;
};

const createWorkspaceItems = (workspaces) => {
  return workspaces.map(workspace => ({
    name: workspace.name || 'Unnamed Workspace',
    url: workspace.link || workspace.url || null,
    type: workspace.type || 'unknown',
    visibility: workspace.visibility || 'unknown'
  }));
};

const createRoleItems = (roles) => {
  return roles.map(role => ({
    name: `${role.scope || 'Unknown Role'}: ${role.permissions || 'No permissions'}`,
    url: null
  }));
};

export {
  getWorkspaceTypeColor,
  getWorkspaceVisibilityColor,
  getRoleColor,
  groupWorkspacesByType,
  groupWorkspacesByVisibility,
  groupRolesByScope,
  getWorkspaceDisplayLabel,
  getRoleDisplayLabel,
  createWorkspaceItems,
  createRoleItems
};




